import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { BaseUrl } from '../../../contexts/baseUrl/baseUrl';

const CorporateList = ({
  match,
  getCorpClientList,
  corpClientList,
  deleteCorpClient,
  updateCorpClient,
}) => {
  const headers = ['Name Of Company', 'Total Clients', 'Created On', 'Actions'];
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (getCorpClientList !== null)
      (async () => {
        setIsLoading(true);
        await getCorpClientList(match.params.id);
        setIsLoading(false);
      })();
  }, [getCorpClientList]);

  useEffect(() => {
    if (refresh === true)
      (async () => {
        setIsLoading(true);
        await getCorpClientList(match.params.id);
        setIsLoading(false);
      })();
  }, [refresh]);

  useEffect(() => {
    const actions = [
      {
        name: 'Edit Client',
        link: '',
      },
      { name: 'Delete Client', link: '' },
      {
        name: 'Manage POC',
        link: `/dashboard/brand-activation/corporate-client/poc/${match.params.id}`,
      },
    ];

    const tableData = ['id', 'name', 'clientTotal', 'created_at'];

    if (corpClientList && corpClientList) {
      const data = corpClientList.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: actions,
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          // obj["id"] = obj["site_id"]; // Assign new key
          // delete obj["site_id"]; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(
        Math
          .ceil
          // corpClientList.resultSets.total / corpClientList.resultSets.per_page
          ()
      );
    } else {
      setListData([]);
    }
  }, [corpClientList]);

  const headerBtns = () => {
    return (
      <Link
        to={`/dashboard/brand-activation/add-corporate-client/${match.params.id}`}
        className="btn btn-primary"
      >
        {localization.addCorporateClient}
      </Link>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getCorpClientList(filter, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.manageCorporateClient}
      isLoading={isLoading}
      Buttons={headerBtns}
      isGoback
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={corpClientList && corpClientList.resultSets}
        deleteCorpClient={deleteCorpClient}
        updateCorpClient={updateCorpClient}
        srNo={corpClientList?.from}
        refreshPage={(val) => {
          if (val === true) {
            setRefresh(true);
          }
        }}
      />
    </Layout>
  );
};

export default CorporateList;
